document.querySelectorAll('[data-filters-panel]').forEach((panel) => {
  const openBtn = document.querySelector(`[data-filters-open][aria-controls="${panel.id}"]`);
  if (!openBtn) return;

  const open = () => {
    panel.classList.add('is-open');
    panel.querySelector('[data-filters-close]')?.focus();
    document.documentElement.style.overflow = 'hidden';
  };
  const close = () => {
    panel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openBtn.focus();
  };

  openBtn.addEventListener('click', open);
  panel.querySelectorAll('[data-filters-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel.classList.contains('is-open')) close();
  });

  panel.querySelectorAll('[data-filter-input]').forEach((input) => {
    input.addEventListener('change', () => input.form.requestSubmit());
  });
});

document.querySelectorAll('[data-sort-select]').forEach((select) => {
  select.addEventListener('change', () => select.form?.requestSubmit());
});

// Draggable dual-handle price range slider. Values are whole numbers in the
// shop's currency (matching the number inputs it stays in sync with).
document.querySelectorAll('[data-price-range]').forEach((container) => {
  const slider = container.querySelector('[data-price-slider]');
  const fill = container.querySelector('[data-price-fill]');
  const minHandle = container.querySelector('[data-price-handle="min"]');
  const maxHandle = container.querySelector('[data-price-handle="max"]');
  const minInput = container.querySelector('[data-price-input="min"]');
  const maxInput = container.querySelector('[data-price-input="max"]');
  if (!slider || !minHandle || !maxHandle || !minInput || !maxInput) return;

  const rangeMin = Number(container.dataset.rangeMin) || 0;
  const rangeMax = Number(container.dataset.rangeMax) || 0;
  const span = rangeMax - rangeMin;
  if (span <= 0) return;

  const clamp = (value, lo, hi) => Math.min(Math.max(value, lo), hi);
  const pctFor = (value) => ((value - rangeMin) / span) * 100;

  let minVal = minInput.value !== '' ? Number(minInput.value) : rangeMin;
  let maxVal = maxInput.value !== '' ? Number(maxInput.value) : rangeMax;

  const render = () => {
    const leftPct = pctFor(minVal);
    const rightPct = pctFor(maxVal);
    minHandle.style.left = `${leftPct}%`;
    maxHandle.style.left = `${rightPct}%`;
    fill.style.left = `${leftPct}%`;
    fill.style.right = `${100 - rightPct}%`;
    minHandle.setAttribute('aria-valuenow', Math.round(minVal));
    maxHandle.setAttribute('aria-valuenow', Math.round(maxVal));
  };

  const commit = () => {
    const roundedMin = Math.round(minVal);
    const roundedMax = Math.round(maxVal);
    const nextMin = roundedMin === rangeMin ? '' : String(roundedMin);
    const nextMax = roundedMax === rangeMax ? '' : String(roundedMax);
    if (minInput.value !== nextMin) {
      minInput.value = nextMin;
      minInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (maxInput.value !== nextMax) {
      maxInput.value = nextMax;
      maxInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const valueFromClientX = (clientX) => {
    const rect = slider.getBoundingClientRect();
    const pct = clamp((clientX - rect.left) / rect.width, 0, 1);
    return rangeMin + pct * span;
  };

  const startDrag = (handle, isMin) => (downEvent) => {
    downEvent.preventDefault();
    handle.setPointerCapture(downEvent.pointerId);
    handle.classList.add('is-dragging');

    const move = (moveEvent) => {
      const value = valueFromClientX(moveEvent.clientX);
      if (isMin) {
        minVal = clamp(value, rangeMin, maxVal);
      } else {
        maxVal = clamp(value, minVal, rangeMax);
      }
      render();
    };
    const stop = () => {
      handle.classList.remove('is-dragging');
      handle.removeEventListener('pointermove', move);
      handle.removeEventListener('pointerup', stop);
      handle.removeEventListener('pointercancel', stop);
      commit();
    };
    handle.addEventListener('pointermove', move);
    handle.addEventListener('pointerup', stop);
    handle.addEventListener('pointercancel', stop);
  };

  minHandle.addEventListener('pointerdown', startDrag(minHandle, true));
  maxHandle.addEventListener('pointerdown', startDrag(maxHandle, false));

  const step = Math.max(1, Math.round(span / 100));
  const keyHandler = (isMin) => (event) => {
    let delta = 0;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') delta = -step;
    else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') delta = step;
    else if (event.key === 'Home') delta = isMin ? rangeMin - minVal : minVal - maxVal;
    else if (event.key === 'End') delta = isMin ? maxVal - minVal : rangeMax - maxVal;
    else return;
    event.preventDefault();
    if (isMin) {
      minVal = clamp(minVal + delta, rangeMin, maxVal);
    } else {
      maxVal = clamp(maxVal + delta, minVal, rangeMax);
    }
    render();
    commit();
  };
  minHandle.addEventListener('keydown', keyHandler(true));
  maxHandle.addEventListener('keydown', keyHandler(false));

  // Typing directly into the number inputs keeps the slider visuals in sync.
  minInput.addEventListener('input', () => {
    const value = minInput.value === '' ? rangeMin : Number(minInput.value);
    minVal = clamp(value, rangeMin, maxVal);
    render();
  });
  maxInput.addEventListener('input', () => {
    const value = maxInput.value === '' ? rangeMax : Number(maxInput.value);
    maxVal = clamp(value, minVal, rangeMax);
    render();
  });
});
